import { BaseControlOption } from '../control-options/control-option.interface';
import { UiControl } from './ui-control.model';

export class TextAreaControl extends UiControl<string> {

  rows: number;

  constructor(id: string, label: string, value: string, ...options: BaseControlOption[]) {
    super(id, label, value, true, options);

    this.className = "TextAreaControl";
    this.rows = 3;
  }

}
